import React, { useEffect, useState } from "react";
import { Quilleditor } from "../../Components/Quilleditor/Quilleditor";
import {
  resumeAdd,
  resumeEditActions,
  getResumeById,
} from "../../Store/Actions/ResumeActions";
import { useHistory, useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Editoroptions from "../../Components/Editoroptions/Editoroptions";
import Modal from "react-bootstrap/Modal";
import Template from "../../Components/CoverTemplates/TemplateOne/TemplateOne";
import AddressForm from "./addressForm";
import ContentField from "./ContentField";
import { RESUME_PREVIEW_RESET } from "../../Store/Constants/ResumeConstants";
import ChangeResumeOrder from "../../hooks/editor/changeResumeOrder";

import "./CoverEditor.scss";
const CoverMobileEditor = ({
  resumeFields,
  setResumeFields,
  handleEditorChange,
  resumeUpdate,
  resumeHandler,
  changeHeaderSettings,
}) => {
  return (
    <>
      <div className="covereditor">
        <div className=" covereditor">
          <AddressForm
            title="Personal Details"
            sectionId="from"
            resumeFields={resumeFields}
            setResumeFields={setResumeFields}
            handleEditorChange={handleEditorChange}
            resumeUpdate={resumeUpdate}
            resumeHandler={resumeHandler}
            changeHeaderSettings={changeHeaderSettings}
          />
          <AddressForm
            title="Employer Details"
            sectionId="to"
            resumeFields={resumeFields}
            setResumeFields={setResumeFields}
            handleEditorChange={handleEditorChange}
            resumeUpdate={resumeUpdate}
            resumeHandler={resumeHandler}
            changeHeaderSettings={changeHeaderSettings}
          />
          <ContentField
            title="Letter Details"
            sectionId="content"
            resumeFields={resumeFields}
            setResumeFields={setResumeFields}
            handleEditorChange={handleEditorChange}
            resumeUpdate={resumeUpdate}
            resumeHandler={resumeHandler}
            changeHeaderSettings={changeHeaderSettings}
          />
        </div>
      </div>
    </>
  );
};

export default CoverMobileEditor;
